<template>
  <div class="home">
	<header>
		<h1>
			<img src="/images/7upspot.gif" />
			<span class="color_1"> W</span>
			<span class="color_2">el</span>
			<span class="color_3">co</span>
			<span class="color_4">m</span>
			<span class="color_5">e </span>
			<span class="color_6">to</span>
			<blink>
				<span class="color_7"> d</span>
				<span class="color_8">u</span>
				<span class="color_9">ch</span>
				<span class="color_0">en</span>
				<span class="color_a">g.</span>
				<span class="color_b">me</span>
			</blink>
		</h1>
		<h3>The awesome corner of the Interweb</h3>
		<marquee>"good at free bad advice" 
			<span class="spacer"></span> 
			"ask me anything"
			<span class="spacer"></span> 
			"the world is my oyster"
		</marquee>
	</header>
	<section>
	<div id="menu">
		<p>pLeAsE fOllOw tHe lInKs bElOw tO kNoW aBoUt DU cHeNg</p>
		<router-link to="/work" class="color_1">WoRk</router-link>
		<span class="spacer"></span>
		<router-link to="/life" class="color_2">LiFe</router-link>
	</div>
	</section>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
}
</script>

<style scoped>
.color_1 { color: #FF0000; }
.color_2 { color: #FF5A00; }
.color_3 { color: #FFB400; }
.color_4 { color: #4Bff00; }
.color_5 { color: #00ff00; }
.color_6 { color: #00ff5A; }
.color_7 { color: #00B4ff; }
.color_8 { color: #005Aff; }
.color_9 { color: #0000ff; }
.color_0 { color: #4B00ff; }
.color_a { color: #A500ff; }
.color_b { color: #FF00ff; }

.spacer {
	display: inline-block;
	width: 3em;
}

marquee {
	max-width: 600px;
	font-size: 12px;
}
marquee .spacer {
	width: 20em;
}

blink {
    animation-duration: 1s;
    animation-name: blink;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
@keyframes blink {
	0% {
		opacity: 0;
	}
	40% {
		opacity: 0;
	}
	41% {
		opacity: 1;
	}
	99% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue